export class NovoAtendimento {
  descricaoInicial: string;
  descricao: string;
  tipoGerado: number;
  pessoaId: number;
  status: number;
  valorPotencial: number;
  responsavel: number;
}
